import { render, staticRenderFns } from "./LabelDesigner.vue?vue&type=template&id=20849c7f&scoped=true&"
import script from "./LabelDesigner.vue?vue&type=script&lang=js&"
export * from "./LabelDesigner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20849c7f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20849c7f')) {
      api.createRecord('20849c7f', component.options)
    } else {
      api.reload('20849c7f', component.options)
    }
    module.hot.accept("./LabelDesigner.vue?vue&type=template&id=20849c7f&scoped=true&", function () {
      api.rerender('20849c7f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/featureOnePage/webParts/formField/LabelDesigner.vue"
export default component.exports